import { NBSP } from 'shared/constants/symbols';
import { TFiveOrSixUtpBlock } from 'shared/types/utp';

export const UTP: TFiveOrSixUtpBlock = [
  {
    title: [
      { value: '20 млн активных пользователей в месяц:', isBold: true },
      { value: ' широкая аудитория в сегменте недвижимости' },
    ],
    image: 'human',
  },
  {
    title: [
      { value: `Чистая и проверенная база с${NBSP}маркировкой ` },
      { value: `«Проверено${NBSP}Циан»`, isBold: true },
    ],
    image: 'checked',
  },
  { title: [{ value: 'Сопровождение и поддержка хостов на каждом этапе' }], image: 'human-talk' },
  { title: [{ value: 'Прозрачные правила без скрытых комиссий' }], image: 'rules' },
  { title: [{ value: 'Бесплатная страховка имущества как стандарт' }], image: 'protect' },
  {
    title: [
      { value: 'Программа лояльности для хостов, которые соблюдают правила и предоставляют качественный сервис' },
    ],
    image: 'star-in-circle',
  },
];
